module.exports = __webpack_public_path__ + "static/img/no_data.92ce4507.png";